export const IOS_APP_STORE = "https://apps.apple.com/cn/app/id1054598922";

export const ANDROID_MARKET_FALLBACK =
  "https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn";

export const PAGE_TITLE = "奶昔大哥直播中";

/** 分享 H5 主视觉切图 */
export const SHARE_H5_BG_IMG = "https://img.mcd.cn/gallery/79fbab2b62a0231c.png";

/** 打开看看 / 底部 CTA 按钮切图 */
export const SHARE_H5_BTN_IMG = "https://img.mcd.cn/gallery/133cd1849e9ad51e.png";

/** 推荐餐品模块背景（与弹幕区底对齐，右侧留白由样式控制） */
export const RECOMMEND_MEAL_CARD_BG = "https://img.mcd.cn/gallery/6bdf7ecb12d05f4a.png";

export const SHARE_GUIDE_TEXT =
  "我在奶昔大哥看直播，每日猜球赢世界杯门票，你也来试试吧！";

export const OPEN_BTN_IMG_URL = 'https://img.mcd.cn/gallery/da275f1746485147.png'

export const BOTTOM_CTA_TEXT = "去麦当劳App 看奶昔大哥直播";

/** 呼起 App RN 直播间（FifaMatchLive），三端页名与原生约定一致 */
const LIVE_DEEPLINK =
  "mcdapp://page?iosPageName=MCDReactNativeViewController&androidPageName=com.mcd.library.rn.McdReactNativeActivity&harmonyPageName=RNPage&parameters=" +
  encodeURIComponent(
    JSON.stringify({
      rctModule: "campaign",
      rctModuleName: "FifaMatchLive",
      rctModuleParams: { showBg: "true" },
    })
  );

export const APP_OPEN = {
  liveExtInfo: LIVE_DEEPLINK,
};

export type DanmakuItem = {
  nickname: string;
  avatar: string;
  content: string;
};

const DANMAKU_AVATARS = [
  "https://img.mcd.cn/gallery/eb11e654d451c20e.png",
  "https://img.mcd.cn/gallery/199a6d809c6a7bc5.png",
  "https://img.mcd.cn/gallery/874a484f62812ea3.png",
  "https://img.mcd.cn/gallery/1bee234362e6d44d.png",
];

/** 弹幕池（昵称/头像/文案），页面静态展示前 DANMAKU_VISIBLE_COUNT 条 */
export const MOCK_DANMAKU_POOL: DanmakuItem[] = [
  { nickname: "扭**棒", avatar: DANMAKU_AVATARS[0], content: "预测了巴西胜利!" },
  { nickname: "麦**多", avatar: DANMAKU_AVATARS[1], content: "预测了阿根廷胜利!" },
  { nickname: "薯**子", avatar: DANMAKU_AVATARS[2], content: "来了" },
  { nickname: "粉**会", avatar: DANMAKU_AVATARS[3], content: "预测了法国胜利!" },
  { nickname: "星**光", avatar: DANMAKU_AVATARS[0], content: "预测了英格兰胜利!" },
  { nickname: "汉**宝", avatar: DANMAKU_AVATARS[1], content: "来了" },
  { nickname: "可**乐", avatar: DANMAKU_AVATARS[2], content: "预测了西班牙胜利!" },
  { nickname: "甜**筒", avatar: DANMAKU_AVATARS[3], content: "预测了葡萄牙胜利!" },
  { nickname: "金**门", avatar: DANMAKU_AVATARS[0], content: "来了" },
  { nickname: "麦**旋", avatar: DANMAKU_AVATARS[1], content: "预测了德国胜利!" },
  { nickname: "脆**鸡", avatar: DANMAKU_AVATARS[2], content: "预测了荷兰胜利!" },
  { nickname: "大**叔", avatar: DANMAKU_AVATARS[3], content: "来了" },
  { nickname: "奶**昔", avatar: DANMAKU_AVATARS[0], content: "预测了比利时胜利!" },
  { nickname: "双**层", avatar: DANMAKU_AVATARS[1], content: "预测了克罗地亚胜利!" },
  { nickname: "小**薯", avatar: DANMAKU_AVATARS[2], content: "预测了乌拉圭胜利!" },
  { nickname: "安**格斯", avatar: DANMAKU_AVATARS[3], content: "预测了墨西哥胜利!" },
  { nickname: "麦**辣", avatar: DANMAKU_AVATARS[0], content: "预测了韩国胜利!" },
  { nickname: "芝**士", avatar: DANMAKU_AVATARS[1], content: "预测了日本胜利!" },
  { nickname: "板**烧", avatar: DANMAKU_AVATARS[2], content: "预测了瑞士胜利!" },
  { nickname: "麦**咖啡", avatar: DANMAKU_AVATARS[3], content: "预测了澳大利亚胜利!" },
  { nickname: "早**", avatar: DANMAKU_AVATARS[0], content: "预测了加拿大胜利!" },
  { nickname: "麦**罗", avatar: DANMAKU_AVATARS[1], content: "预测了卡塔尔胜利!" },
  { nickname: "朱**古力", avatar: DANMAKU_AVATARS[2], content: "预测了摩洛哥胜利!" },
  { nickname: "麦**乐送", avatar: DANMAKU_AVATARS[3], content: "预测了瑞典胜利!" },
  { nickname: "青**椒", avatar: DANMAKU_AVATARS[0], content: "预测了哥伦比亚胜利!" },
  { nickname: "甜**酸酱", avatar: DANMAKU_AVATARS[1], content: "预测了埃及胜利!" },
  { nickname: "麦**小", avatar: DANMAKU_AVATARS[2], content: "预测了沙特阿拉伯胜利!" },
  { nickname: "麦**文", avatar: DANMAKU_AVATARS[3], content: "预测了伊朗胜利!" },
  { nickname: "康**尼尔", avatar: DANMAKU_AVATARS[0], content: "预测了塞内加尔胜利!" },
  { nickname: "麦**西", avatar: DANMAKU_AVATARS[1], content: "预测了厄瓜多尔胜利!" },
];

export const DANMAKU_VISIBLE_COUNT = 4;

/** 直播间分享页视觉稿基准宽度 */
export const LIVE_SHARE_DESIGN_WIDTH = 393;
